import React, { memo } from 'react';
import classNames from 'classnames';

import { ResponsiveSize } from '@bingads-webui-campaign-react/pmax-overview-responsive-utils';

import { BudgetCard } from './components/budget-card';
import { BidStrategyCard } from './components/bid-strategy-card';
import { CampaignStatusCard } from './components/campaign-status-card';
import { LinkedInMemberTokenWarningBanner } from './components/linkedin-member-token-warning-banner';
import { shouldUseFullWidthCards, useCampaignStatusSummaryCardsStyles } from './styles/styles';

type CampaignStatusSummaryCardsProps = {
  campaignStatusContentReady: Function;
  budgetContentReady: Function;
  bidStrategyContentReady: Function;
  responsiveSize: ResponsiveSize;
  isLinkedInCampaignOverview?: boolean;
};

export const CampaignStatusSummaryCards: React.FunctionComponent<CampaignStatusSummaryCardsProps> =
  memo(({
    campaignStatusContentReady, budgetContentReady, bidStrategyContentReady, responsiveSize, isLinkedInCampaignOverview,
  }: CampaignStatusSummaryCardsProps) => {
    const classes = useCampaignStatusSummaryCardsStyles();
    return (
      <>
        {/* This is a temporary solution for LinkedIn token warning banner, will remove it once we migrate to 2L token */}
        {isLinkedInCampaignOverview && <LinkedInMemberTokenWarningBanner />}
        <div className={classNames('ba-campaign-status-summary-cards', classes.container, shouldUseFullWidthCards(responsiveSize) && classes.fullWidthCards)}>
          <CampaignStatusCard contentReady={campaignStatusContentReady} />
          <BudgetCard contentReady={budgetContentReady} />
          <BidStrategyCard contentReady={bidStrategyContentReady} />
        </div>
      </>
    );
  });

CampaignStatusSummaryCards.defaultProps = {
  isLinkedInCampaignOverview: false,
};
